<div class="flex flex-col gap-4">
    <!-- Year Selector -->
    <div class="flex items-center gap-2 justify-end">
        <label for="year-select" class="text-sm font-medium">Year:</label>
        <p-dropdown 
            id="year-select"
            [options]="yearOptions()" 
            [ngModel]="selectedYear()"
            (ngModelChange)="onYearChange($event)"
            optionLabel="label"
            optionValue="value"
            [style]="{'width': '120px'}"
            placeholder="Select Year"
        ></p-dropdown>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <!-- Week and Month Column -->
        <div class="flex flex-col gap-8">
            <ng-container *ngFor="let stat of weekMonthStats()">
                <div class="flex flex-col items-center gap-4">
                    <div class="flex items-center gap-2">
                        <div class="text-xl font-semibold">{{stat.title}}</div>
                        <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                           [pTooltip]="stat.tooltip"
                           tooltipPosition="top"></fa-icon>
                    </div>
                    <div>
                        <p-knob 
                            [ngModel]="stat.displayPercentage"
                            [readonly]="true"
                            [size]="120"
                            [strokeWidth]="10"
                            valueColor="rgba(28, 132, 198, 0.7)"
                            [valueTemplate]="stat.percentage.toString() + '%'"
                        ></p-knob>
                    </div>
                    <div class="text-center">
                        <div class="text-2xl font-semibold">{{stat.value | number}}</div>
                        <div class="text-sm text-gray-600">Goal: {{stat.goal | number}}</div>
                        <div class="text-sm text-gray-600">{{stat.teams}} teams</div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Other Stats -->
        <ng-container *ngFor="let stat of otherStats()">
        <div class="flex flex-col items-center h-full" *ngIf="stat.show">
            <div class="flex items-center gap-2">
                <div class="text-xl font-semibold">{{stat.title}}</div>
                <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                   [pTooltip]="stat.tooltip"
                   tooltipPosition="top"></fa-icon>
            </div>
            <div class="dual-knob flex-1 justify-between py-4">
                <div class="knob-item">
                    <p-knob 
                        [ngModel]="stat.originalDisplayPercentage"
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        valueColor="rgba(28, 132, 198, 0.7)"
                        [valueTemplate]="stat.originalPercentage.toString() + '%'"
                    ></p-knob>
                    <div class="knob-label">{{stat.originalValue | number}}</div>
                    <div class="text-center">
                        <div>Original</div>
                        <div class="text-sm text-gray-600">Goal: {{stat.originalGoal | number}}</div>
                    </div>
                </div>
                <div class="knob-item">
                    <p-knob 
                        [ngModel]="stat.actualDisplayPercentage"
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        valueColor="rgba(28, 132, 198, 0.7)"
                        [valueTemplate]="stat.actualPercentage.toString() + '%'"
                    ></p-knob>
                    <div class="knob-label">{{stat.actualValue | number}}</div>
                    <div class="text-center">
                        <div>Actual</div>
                        <div class="text-sm text-gray-600">Goal: {{stat.actualGoal | number}}</div>
                    </div>
                </div>
            </div>
            <div class="text-sm text-gray-600">{{stat.teams}} teams</div>
        </div>
    </ng-container>
    </div>
</div> 